export default "__VITE_ASSET__DkEvSiIa__"